import { render, staticRenderFns } from "./BankReceiptsList.vue?vue&type=template&id=2240dafc&scoped=true"
import script from "./BankReceiptsList.vue?vue&type=script&lang=js"
export * from "./BankReceiptsList.vue?vue&type=script&lang=js"
import style0 from "./BankReceiptsList.vue?vue&type=style&index=0&id=2240dafc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2240dafc",
  null
  
)

export default component.exports